import EnjoyHint from 'xbs-enjoyhint/src/enjoyhint'
import 'leaflet.coordinates/dist/Leaflet.Coordinates-0.1.5.src'

var flag = true

$('#btn-notice-modal-close').on('click', function() {
    $('#notice-modal').modal('hide')
})

$('#btn-tutorial').on('click', function () {
    webgis.init.enjoyhint.start()
})
$('#btn-frp').on('click', function () {
    webgis.frp.show($(this).is(":checked"))
})

$('#btn-area-search').on('click', async function () {
    /*
    if ($('#select-biomes').val() == 'AM') {
        $('#div-select-historic').hide()
    } else {
        $('#div-select-historic').show()
    }
    */
    webgis.util.clean.all()
    await webgis.refresh.area()
    webgis.refresh.nrt()

    //$('#select-nrt').val('0')
    // $('#select-nrt').trigger("chosen:updated")

    //$('#select-historic').val('0')
    //$('#select-historic').trigger("chosen:updated")
    /*
    if (flag) {
        webgis.refresh.nrt()
    } else {
        webgis.refresh.historic()
    }
    */
})

$('#select-nrt').on('change', function () {
    webgis.util.clean.ceasefire()
    webgis.refresh.nrt()
})

$('#select-historic').on('change', function () {
    webgis.util.clean.ceasefire()
    webgis.refresh.historic()
    //webgis.upload.list()
})

$('.base-layer').on('click', function () {
    $('.base-layer').prop("checked", false)
    $(this).prop("checked", true)
    webgis.refresh.base($(this).attr("id"))
})

$('.btn-side-layer').on('click', function () {
    const target = $(this).attr("target")
    $(`#${target}`).modal('show')
})

$('.auxiliary-layer').on('click', function () {
    const layername = $(this).attr("layer")
    const cql_filter = $(this).attr("cql-filter")

    if (layername in webgis.layers) {
        webgis.map.removeLayer(webgis.layers[layername])
        delete webgis.layers[layername]
    } else {
        webgis.refresh.auxiliares(layername, cql_filter)
    }
})

$('.close-modal').on('click', function () {
    const target = $(this).attr("target")
    $(`#${target}`).modal('hide')
})

$('#btn-toggle-nrt').on('click', function () {
    webgis.util.clean.historic()

    $('#select-historic').val(0)
    //$('#select-historic').trigger("chosen:updated")

    $('#btn-toggle-nrt').addClass('active')
    $('#btn-toggle-historic').removeClass('active')

    $('#dropdown-select-historic').addClass('d-none')
    $('#dropdown-select-nrt').removeClass('d-none')
    $('#legend-nrt').removeClass('d-none')

    flag = true

    //$('#form-nrt').show()
    //webgis.upload.list()
})

$('#btn-toggle-historic').on('click', function () {
    webgis.util.clean.nrt()

    $('#select-nrt').val(0)
    //$('#select-nrt').trigger("chosen:updated")

    $('#btn-toggle-historic').addClass('active')
    $('#btn-toggle-nrt').removeClass('active')

    $('#dropdown-select-nrt').addClass('d-none')
    $('#legend-nrt').addClass('d-none')
    $('#dropdown-select-historic').removeClass('d-none')
    
    flag = false
    //$('#form-historic').show()
})

$('#input-photos').on('click', function () {
    webgis.upload.list()
})

$('#ceasefire_date').on('change', function () {
    webgis.util.clean.all()
    webgis.ceasefire.change($(this).val())
})


$("body").on("click", "#btn-chart", function () {
    webgis.refresh.ceasefire($(this).attr("location-id"), $(this).attr("location-code"))
})

// Colapse event
$("body").on("click", "#collapse-one-btn,#collapse-two-btn", function (e) {
    if ($(this).attr("id") == "collapse-one-btn") {
        webgis.util.clean.ceasefire()
    }
    else {
        webgis.util.clean.historic()
        webgis.util.clean.nrt()
        webgis.util.clean.area()

        if ($("#ceasefire_date").val() == "") {
            $("#ceasefire_date").val(`${new Date().getFullYear()}-${("0" + (new Date().getMonth() + 1)).slice(-2)}-${("0" + new Date().getUTCDate()).slice(-2)}`)
            $("#ceasefire_date").trigger('change')
        }
    }
})

$('#btn-coordinates-search').on('click', function () {
    webgis.search.coords()
})


// statistic UPLOAD
$("#statistic-file").on('change', function (e) {

    $("#label-file").text($(this).val().replace(/^.*[\\\/]/, ''))
    var reader = new FileReader();
    reader.onload = webgis.statistic.view
    reader.readAsText(e.target.files[0]);

})

$('#btn-statistic-file').on('click', function () {
    webgis.statistic.insert()
})

$('body').on('click', '.statistic-item', function () {
    $(".statistic-item").removeClass("btn-info")
    $(this).addClass("btn-info")
    $("#statistic-actions").fadeIn(1000)
    webgis.statistic.show($(this).attr('statistic-id'), $(this).text(), $(this).attr('created-at'))
})

$('body').on('click', '.card-header', function () {
    webgis.util.clean.all()
})


const webgis = {
    workspace: '/platform',
    area: null,
    base: {
        'google': "https://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}",
        'osm': "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
        'otm': "https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png",
        'land': "https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png",
        'satellite': "https://www.google.cn/maps/vt?lyrs=s@189&gl=cn&x={x}&y={y}&z={z}"
    },
    chart: null,
    map: null,
    layers: [],
    polygons: [],
    ceasefire: {
        content: (feature, date) => {
            // <div class="col-3" ><button class="btn btn-secondary text-light mt-2 align-middle" id="btn-chart" location-id="${feature.id}" location-code="${feature.code}" ><i class="fas fa-chart-line"></i></button></div ></div >
            const fields = [
                { "name": "MN", "title": "MUNICÍPIO" },
                { "name": "uf", "title": "ESTADO" },
                { "name": "RO", "title": "ROI" },
                { "name": "UC", "title": "UC" },
                { "name": "TI", "title": "TI" },
                { "name": "color", "title": "PERIGO" },
                { "name": "ssr", "title": "SSR" },
                { "name": "dsr", "title": "DSR" },
                { "name": "fwi", "title": "FWI" },
                { "name": "bui", "title": "BUI" },
                { "name": "isi", "title": "ISI" },
                { "name": "dc", "title": "DC" },
                { "name": "ffm", "title": "FFM" },
                { "name": "dmc", "title": "DMC" }
            ]

            let tr_lines = ""
            fields.forEach(item => {

                if (feature[item['name']]) {
                    tr_lines += `
                    <tr>
                        <th scope="row" class="font-weight-bold lasa-blue-color text-right">${item['title']}:</th>
                        <th scope="row" class="font-weight-bold lasa-orange-color">${feature[item['name']]}</th>
                    </tr>
                `
                }
            })


            let container = $('<div />')
            container.html(`
                <div class="row" >
                    <div class="col-12"><h4 class="text-center lasa-orange-color align-middle">${date.substring(8, 10)}/${date.substring(5, 7)}/${date.substring(0, 4)}</h4></div>
                </div>
                <table class="table table-hover table-responsive table-sm mt-2">
                    <tbody>
                        ${tr_lines}
                    </tbody >
                </table >
            `)
            return container[0]
        },
        change: (date) => {

            const colors = {
                1: { "color": "#00ff2c", "name": "Baixo" },
                2: { "color": "#f8ff00", "name": "Moderado" },
                3: { "color": "#ff5e00", "name": "Alto" },
                4: { "color": "#ff0000", "name": "Muito Alto" },
                5: { "color": "#8c0000", "name": "Extremo" },
                6: { "color": "#aa0046", "name": "Excepcional" }
            }

            $.getJSON({ url: `${webgis.workspace}/ceasefire/${date}` }).done(function (data) {
                if (webgis.layers.ceasefire)
                    webgis.map.removeLayer(webgis.layers.ceasefire)

                webgis.layers.ceasefire = L.layerGroup()

                webgis.ceasefire.restructure(data).forEach(feature => {

                    let layer = new L.GeoJSON(feature.geom)

                    layer.setStyle({
                        color: 'white',
                        strokeOpacity: 0.5,
                        weight: '1',
                        dashArray: '10, 10',
                        dashOffset: '10',
                        fillColor: colors[feature.danger]['color'],
                        fillOpacity: 0.5
                    })

                    layer.on('mouseover', function () {
                        this.setStyle({
                            'fillColor': '#0000ff'
                        })
                    })

                    layer.on('mouseout', function () {
                        this.setStyle({
                            'fillColor': colors[feature.danger]['color']
                        })
                    })

                    feature.color = feature.danger + ' - ' + colors[feature.danger]['name']
                    layer.bindPopup(webgis.ceasefire.content(feature, date,), { maxWidth: 600 })

                    webgis.layers.ceasefire.addLayer(layer)
                    webgis.map.flyTo([-17.877, -55.877], 6)
                })
                webgis.map.addLayer(webgis.layers.ceasefire)

                $.notify(`Perigo de fogo atualizado para o dia ${date.split("-")[2]}/${date.split("-")[1]}/${date.split("-")[0]}`, {
                    className: "info",
                    position: "right bottom"
                })
            })
        },
        restructure: (data) => {

            let locations = []

            data.forEach(item => {
                if (!locations.hasOwnProperty(item.id)) {
                    locations[item.id] = { "id": item.id, "uf": item.uf, "danger": item.danger, "ssr": item.ssr, "dsr": item.dsr, "fwi": item.fwi, "bui": item.bui, "isi": item.isi, "dc": item.dc, "ffm": item.ffm, "dmc": item.dmc, "geom": JSON.parse(item.st_asgeojson) }
                }

                locations[item.id][item.category_id] = item.name.replaceAll(' / ', '<br/>')
            })

            return locations
        }
    },
    frp: {
        date: new Date(Date.now() - 86400000).toISOString().split("T")[0],
        icon: (frp) => {
            frp = frp < 20 ? 20 : frp

            const size = Math.pow(Math.round(Math.log(frp)), 1.7) + 5

            return L.icon({
                iconUrl: 'img/logo/fire-logo-unique.png',
                iconSize: [size, size] // size of the icon
            })
        },
        get: (initial) => {


            $.ajax({ url: `${webgis.workspace}/frp` }).done(function (items) {
                if (!initial) {
                    webgis.frp.show(false)
                    $.notify(`Atualizando camada de Fogo Ativo`, { className: "info", position: "right bottom" })
                }

                webgis.layers['frp'] = L.markerClusterGroup({
                    chunkedLoading: true,
                    showCoverageOnHover: false,
                    spiderfyOnMaxZoom: true,
                    zoomToBoundsOnClick: true,
                    maxClusterRadius: function () {
                        if (webgis.map.getZoom() > 13) return 1;
                        else if (webgis.map.getZoom() > 9) return 10;
                        else return 20;
                    },
                    iconCreateFunction: function (cluster) {
                        const quantity = cluster.getAllChildMarkers().length;

                        let size = 30
                        size = L.point(size, size)

                        return L.divIcon({ className: `satellite-fire-icon`, iconSize: size })
                    }
                })

                items.forEach((item) => {
                    let marker = L.marker([item.latitude, item.longitude], { icon: webgis.frp.icon(item.frp) })
                    marker.bindPopup(`
                        <a href="http://maps.google.com/maps?z=12&t=m&q=loc:${item.latitude}+${item.longitude}" target="_blank">
                            <b>Localização (Google Maps) </b> 
                        </a>
                        <br />
                        <b>Satélite: </b>${item.satellite}<br /> 
                        <b>Data: </b>${item.datetime}<br /> 
                        <b>Intensidade (FRP): </b>${item.frp} MW<br />
                    `)

                    marker.on('mouseover', function (e) {
                        this.openPopup();
                    });

                    webgis.layers['frp'].addLayer(marker)

                })

                setTimeout(function () { webgis.frp.get() }, 7200000)

                if (initial)
                    $("#btn-frp").trigger("click")
                else
                    webgis.frp.show(true)

            })
        },
        show: (checked) => {
            if (!checked) {
                webgis.map.removeLayer(webgis.layers['frp'])
            } else {
                webgis.layers['frp'].addTo(webgis.map)
            }

        }
    },
    init: {
        all: async () => {

            $("#form-historic").hide()
            $('#btn-toggle-nrt').addClass('active')
            $("#dropdown-select-historic").addClass("d-none")

            //Starting LEAFLET MAPS
            webgis.init.maps()

            // Starting CEASEFIRE 
            $("#collapse-two-btn").trigger("click")

            // Starting FRP 
            webgis.frp.get(true)

            // Starting OTHER TOOLS 
            // await webgis.refresh.area()
            //webgis.init.step()
            //webgis.init.upload()
            webgis.init.chart()

            if ($("#user-layer-card").length > 0) {
                webgis.statistic.list()
            }

            if (localStorage.photoUploadModalFlag) {
                $('#upload-modal').modal('show');
                localStorage.removeItem('photoUploadModalFlag');
            } else {
                //webgis.init.enjoyhint.start()
            }

        },
        chart: () => {
            webgis.chart = Highcharts.chart('div-chart', {
                chart: {
                    type: 'line'
                },
                title: {
                    text: 'Histograma de Dados',
                    align: 'center'
                },
                subtitle: {
                    text: 'Source: Test',
                    align: 'center'
                },
                yAxis: {
                    title: {
                        text: 'Índice do Perigo de Fogo',
                    }
                },
                xAxis: {
                    type: 'datetime',
                    labels: {
                        format: '{value:%Y-%m-%d}'
                    }
                },
                plotOptions: {
                    series: {
                        label: {
                            connectorAllowed: true
                        }
                    },
                    area: {
                        marker: {
                            enabled: false,
                            symbol: 'circle',
                            radius: 2,
                            states: {
                                hover: {
                                    enabled: true
                                }
                            }
                        }
                    }
                },
                series: [
                    {
                        "name": "Teste 0",
                        "data": [1111111111, 0]
                    }
                ],
                responsive: {
                    rules: [{
                        condition: {
                            maxWidth: 500
                        }
                    }]
                }
            })
        },
        enjoyhint: {
            start: () => {
                webgis.init.enjoyhint.obj = new EnjoyHint({})
                const enjoyhint_script_steps = [
                    {
                        nextButton: { text: 'Sim' },
                        skipButton: { text: 'Não' },
                        skipButton: { text: 'Fechar' },
                        'next #btn-tutorial': 'Deseja iniciar o tutorial? <br /><b>Aviso:</b> podem ocorrer falhas na apresentação do tutorial de acordo com a configuração do seu dispositivo.'
                    },
                    {
                        nextButton: { text: 'Próximo' },
                        prevButton: { text: 'Voltar' },
                        skipButton: { text: 'Fechar' },
                        'next #biome-card': 'Esta é a área para filtrar as regiões de interesse, deve-se escolher o bioma, a categoria e por fim a região consecutivamente. <br />Logo após, pode-se escolher o tipo de visualização de queimada (Alerta Rápido / Histórico).'
                    },
                    {
                        nextButton: { text: 'Próximo' },
                        prevButton: { text: 'Voltar' },
                        skipButton: { text: 'Fechar' },
                        'next #btn-toggle-nrt': 'Clicando aqui, você pode habilitar/desabilitar a exibição no mapa das áreas queimadas. <br />(A coloração no mapa corresponde ao período selecionado e será exibida a data inicial e final do período escolhido).'
                    },
                    {
                        nextButton: { text: 'Próximo' },
                        prevButton: { text: 'Voltar' },
                        skipButton: { text: 'Fechar' },
                        'next #btn-toggle-historic': 'Clicando aqui, você pode habilitar/desabilitar a exibição do histórico no mapa.'
                    },

                    {
                        nextButton: { text: 'Próximo' },
                        prevButton: { text: 'Voltar' },
                        skipButton: { text: 'Fechar' },
                        'next #select_biomes_chosen': 'Nesta listagem são exibidos os biomas disponíveis.'
                    },
                    {
                        nextButton: { text: 'Próximo' },
                        prevButton: { text: 'Voltar' },
                        skipButton: { text: 'Fechar' },
                        'next #select_categories_chosen': 'Nesta listagem são exibidas as categorias disponíveis do bioma selecionado.'
                    },
                    {
                        nextButton: { text: 'Próximo' },
                        prevButton: { text: 'Voltar' },
                        skipButton: { text: 'Fechar' },
                        'next #select_areas_chosen': 'Nesta listagem são exibidas as regiões de interesse filtradas por bioma e categoria previamente escolhidos.'
                    },
                    {
                        nextButton: { text: 'Próximo' },
                        prevButton: { text: 'Voltar' },
                        skipButton: { text: 'Fechar' },
                        'next #btn-area-search': 'Após escolher a região de interesse, deve-se confirmar. <br />(A área do mapa será direcionada para a região com melhor visualização da mesma).'
                    },
                    {
                        nextButton: { text: 'Próximo' },
                        prevButton: { text: 'Voltar' },
                        skipButton: { text: 'Fechar' },
                        'next #collapse-two-btn': 'Esta é a área do perigo de fogo para a Região da Bacia do Alto Paraguai (BAP), aonde é possível obter o perigo meteorológico de fogo baseado nas previsões. <br />Clicando aqui, você pode escolher o perigo de fogo para o dia atual e os 5 dias seguintes, além das previsões passadas (desde 15/03/2023) <br />As cinco (5) classes de perigo podem ser descritas como: Baixo ; Moderado ; Alto ; Muito Alto ; e Extremo.'
                    },

                    {
                        nextButton: { text: 'Próximo' },
                        prevButton: { text: 'Voltar' },
                        skipButton: { text: 'Fechar' },
                        'next #auxiliaries-card': 'Aqui são exibidas camadas auxiliares para visualização no mapa. NOVAS CAMADAS: ROI, UCs e TIs.'
                    },
                    {
                        nextButton: { text: 'Próximo' },
                        prevButton: { text: 'Voltar' },
                        skipButton: { text: 'Fechar' },
                        'next #background-card': 'Aqui são exibidas as alternativas de camadas de fundo para o mapa.'
                    },
                    {
                        nextButton: { text: 'Finalizar' },
                        prevButton: { text: 'Voltar' },
                        skipButton: { text: 'Fechar' },
                        'next #btn-faq': 'Qualquer dúvida restante acesse nosso FAQ ou entre em contato.'
                    }
                ]

                webgis.init.enjoyhint.obj.set(enjoyhint_script_steps)
                webgis.init.enjoyhint.obj.run()
            }
        },
        upload: () => {
            webgis.upload.list()
        },
        maps: () => {
            webgis.layers['base'] = L.tileLayer(webgis.base['osm'])
            webgis.upload.markers = L.markerClusterGroup({
                showCoverageOnHover: false,
                iconCreateFunction: function (cluster) {
                    return L.divIcon({ html: `<div><img src="${webgis.workspace}/img/icons/camera-cluster.png" width="30" height="30" /></div>` });
                }
            })

            //Page map
            webgis.map = L.map('map', {
                zoomControl: false,
                layers: [webgis.layers['base'], webgis.upload.markers],
                minZoom: 4,
                maxZoom: 14
            })

            webgis.map.setView([-18.2500, -56.2500], 6)
            L.control.zoom({ position: 'topright' }).addTo(webgis.map)
            L.control.scale({ position: 'bottomleft' }).addTo(webgis.map)

            L.control.coordinates({
                position: "topleft", //optional default "bootomright"
                decimals: 2, //optional default 4
                decimalSeperator: ".", //optional default "."
                labelTemplateLat: "Latitude: {y}", //optional default "Lat: {y}"
                labelTemplateLng: "Longitude: {x}", //optional default "Lng: {x}"
                enableUserInput: false, //optional default true
                useDMS: false, //optional default false
                useLatLngOrder: true, //ordering of labels, default false-> lng-lat
                markerType: L.marker, //optional default L.marker
                markerProps: {}, //optional default {},
                labelFormatterLng: function (lng) { return lng + " lng" }, //optional default none,
                labelFormatterLat: function (lat) { return lat + " lat" }, //optional default none
                customLabelFcn: function (latLonObj, opts) { "Geohash: " + encodeGeoHash(latLonObj.lat, latLonObj.lng) } //optional default none
            }).addTo(webgis.map);

            //Statistic map on Modal
            /*
            webgis.statistic.map = L.map('statistic-map', {
                zoomControl: false,
                layers: [L.tileLayer("https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png")],
                minZoom: 4,
                maxZoom: 14
            })
            webgis.statistic.map.setView([-18.2500, -56.2500], 6)
            L.control.zoom({ position: 'topright' }).addTo(webgis.statistic.map)
            */
        },
        step: () => {
            $("#wizard").steps({
                headerTag: "label",
                bodyTag: "section",
                transitionEffect: "slideLeft",
                onFinished: function (event, currentIndex) {
                    webgis.validation.upload()
                },
            })
        }
    },
    refresh: {
        area: async () => {
            const area_id = $('#select-areas').val()
            const categoryId = $('#select-categories').val()

            const area = await $.ajax({ url: `${webgis.workspace}/area/${area_id}` })//.done(function (area) {
            webgis.area = area

            const envelope = L.geoJSON(JSON.parse(area.geojson))
            webgis.map.fitBounds(envelope.getBounds())
            $("#input-coordinates-lat").val(webgis.area.lat)
            $("#input-coordinates-lon").val(webgis.area.lon)
            //webgis.map.flyTo([webgis.area.lat, webgis.area.lon], 6)

            let final_date = new Date()
            let start_date = new Date()

            //final_date.setDate(webgis.area.max.split("-")[2])
            //start_date.setUTCDate(final_date.getUTCDate() - parseInt($('#select-nrt').val()) + 1)

            $('#start_date').val(start_date.toLocaleDateString())
            $('#final_date').val(final_date.toLocaleDateString())

            webgis.layers.area = L.tileLayer.wms('https://alarmes.lasa.ufrj.br/geoserver/wms', {
                layers: `areas:${categoryId}`,
                cql_filter: `ID=${area_id}`,
                transparent: 'true',
                format: 'image/png',
                version: 1.1,
                srs: 'EPSG:4326'
            })

            webgis.layers.area.addTo(webgis.map)


            // $.ajax({ url: `${webgis.workspace}/area/geom/${$('#select-areas').val()}` }).done(function (result) {
            //     if (webgis.layers.area) webgis.map.removeLayer(webgis.layers.area)

            //     webgis.layers['area'] = L.geoJSON(JSON.parse(result.geom), {
            //         color: '#00639f',
            //         fillOpacity: 0,
            //         weight: 1.8
            //     });

            //     webgis.layers['area'].addTo(webgis.map)

            //     webgis.map.flyTo([webgis.area.lat, webgis.area.lon], 6)

            //     $.notify(`Região atualizada para ${area.name}`, { className: "success", position: "right bottom" })
            // })
        },
        auxiliares: (layername, cql_filter) => {

            if (cql_filter) {
                webgis.layers[layername] = L.tileLayer.wms('https://alarmes.lasa.ufrj.br/geoserver/wms', {
                    layers: 'areas',
                    cql_filter: cql_filter,
                    transparent: 'true',
                    format: 'image/png',
                    version: 1.0
                })
            } else {
                webgis.layers[layername] = L.tileLayer.wms('https://alarmes.lasa.ufrj.br/geoserver/wms', {
                    layers: layername,
                    transparent: 'true',
                    format: 'image/png',
                    version: 1.0
                })
            }

            webgis.layers[layername].addTo(webgis.map)
        },
        base: (id) => {
            webgis.layers['base'].setUrl(webgis.base[id])
        },
        burned: (layername, value) => {
            webgis.layers[`nrt-${value}`] = L.tileLayer.wms('https://alarmes.lasa.ufrj.br/geoserver/wms', {
                layers: `${layername}`,
                //cql_filter: `ID=${$('#select-areas option:selected').val()}`,
                transparent: 'true',
                format: 'image/png',
                version: 1.1,
                srs: 'EPSG:4326'
            })

            webgis.layers[`nrt-${value}`].addTo(webgis.map)
        },
        ceasefire: (id, code) => {
            $.getJSON({ url: `${webgis.workspace}/ceasefire/log/${id}` }).done(function (data) {

                let values = []

                data.forEach(item => {
                    values.push([new Date(item['reference_date']).getTime(), item['value']])
                })

                webgis.chart.setTitle(null, { text: `Geometria: ${id} - ${code}` })
                webgis.chart.series[0].update({
                    "name": 'Dados',
                    "data": values
                }, true);

                $("#modal-value").modal("show")
            })
        },
        historic: () => {
            //webgis.util.clean.historic()

            if ($('#select-historic option:selected').val() != "") {
                const biome = $('#select-biomes option:selected').val() == 'AM' ? 'amazonia' : 'cerrado'

                if (webgis.layers['historic'])
                    webgis.map.removeLayer(webgis.layers['historic'])

                webgis.layers['historic'] = L.tileLayer.wms('https://alarmes.lasa.ufrj.br/geoserver/wms', {
                    layers: `historics:historic_${$('#select-historic').val()}`,
                    transparent: 'true',
                    format: 'image/png',
                    version: 1.0
                })

                webgis.layers['historic'].addTo(webgis.map)
            }
        },
        nrt: (id) => {
            webgis.util.clean.nrt()

            $($('#select-nrt option').get().reverse()).each(function (index) {
                if (parseInt($(this).val()) <= parseInt($('#select-nrt option:selected').val()) && $(this).attr("layer")) {
                    webgis.refresh.burned($(this).attr("layer"), $(this).val())
                }
            })

            if (parseInt($('#select-nrt').val()) > 0) {

                const area_id = $('#select-areas').val()

                $.ajax({ url: `${webgis.workspace}/area/${area_id}` }).done(function (area) {
                    $('#nrt-date').prop("hidden", false)
                    webgis.area = area

                    let final_date = new Date()
                    let start_date = new Date()

                    //final_date.setDate(webgis.area.max.split("-")[2])
                    //start_date.setUTCDate(final_date.getUTCDate() - parseInt($('#select-nrt').val()) + 1)

                    $('#start_date').val(start_date.toLocaleDateString())
                    $('#final_date').val(final_date.toLocaleDateString())
                })
            } else {
                $('#nrt-date').prop("hidden", true)
                $('#final_date').val('')
            }
        }
    },
    search: {
        coords: () => {
            const lat = parseFloat($("#input-coordinates-lat").val())
            const lon = parseFloat($("#input-coordinates-lon").val())

            //Bbox Brasil         
            const bbox = turf.polygon([[
                [-38.18232970761716, -82.80742187500002],
                [-38.18232970761716, -26.293750000000014],
                [15.90290641207954, -26.293750000000014],
                [15.90290641207954, -82.80742187500002],
                [-38.18232970761716, -82.80742187500002]
            ]])

            const features = turf.pointsWithinPolygon(turf.point([lat, lon]), bbox)['features']
            if (features.length > 0) {
                $.notify("Mapa direcionado para as coordenadas de busca", { className: "info", position: "right bottom" })
                webgis.map.panTo(new L.LatLng(lat, lon))
            }
            else {
                $.notify("As coordenadas inseridas estão fora do limite", { className: "error", position: "right bottom" })
            }

        }
    },
    statistic: {
        insert: () => {
            $("#label-file").text('')

            if (webgis.layers['statistic'].length == 0) {
                $.notify("Nenhuma geometria a ser enviada...", { className: "error", position: "right bottom" })
                return
            }

            $.notify("O envio será concluído em instantes, aguarde...", { className: "info", position: "right bottom" })

            if (webgis.layers['statistic'] == undefined || webgis.layers['statistic'].toGeoJSON()['features'].length == 0) {
                return;
            }

            $.ajax({
                method: 'POST',
                url: `${webgis.workspace}/statistic/upload`,
                headers: { 'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') },
                data: { 'features': JSON.stringify(webgis.layers['statistic'].toGeoJSON()['features']), 'source': 'W' }
            })
                .done(function (response, a, b) {
                    $.notify(response[1], { className: response[0] ? "success" : "error", position: "right bottom" })
                    webgis.statistic.list()
                })
        },
        list: () => {
            $("#statistic-actions").fadeOut(1000)
            $("#div-statistic-list").html('')

            webgis.util.clean.statistic.all()
            $.getJSON(`${webgis.workspace}/statistic/list`, function (response) {
                response.forEach(item => {
                    webgis.layers[`statistic-${item.id}`] = L.geoJSON(JSON.parse(item.geometry), { fillOpacity: 0, color: '#000000' })
                    $("#div-statistic-list").append(`<button type="button" class="btn list-group-item list-group-item-action lasa-blue-color statistic-item" created-at="${item.created_at.substring(0, 16)}" id="statistic-${item.id}" statistic-id="${item.id}" >${item.name}</button>`)
                })
            })

            $("#div-statistic-list").fadeIn(1000)
        },
        show: (area_id, name, created_at) => {

            $.notify("Buscando estatisticas da área", { className: "info", position: "right bottom" })

            $.ajax({ type: 'GET', url: `${webgis.workspace}/statistic/show/${area_id}` }).done(function (data) {

                $("#statistic-name").html(name)

                data.split("\n").forEach(item => {
                    const splited = item.split(",")
                    $(`#statistic-${splited[0]}`).html(splited[1])
                })

                $("#modal-statistic").modal("show")

                setTimeout(function () {
                    webgis.statistic.map.invalidateSize();

                    webgis.util.clean.statistic.all()
                    webgis.statistic.map.addLayer(webgis.layers[`statistic-${area_id}`])
                    webgis.statistic.map.fitBounds(webgis.layers[`statistic-${area_id}`].getBounds())
                }, 10);
            }).fail(function (jqXHR, textStatus) {
                $.notify("Erro ao subir imagens", { className: "error", position: "right bottom" })
            })

        },
        view: (e) => {
            webgis.util.clean.statistic.specific('upload')
            webgis.layers['statistic'] = []

            let not_intersected = 0
            let collection = JSON.parse(e.target.result)

            collection.features.forEach((feature, index) => {
                if (['Polygon', 'MultiPolygon'].includes(feature.geometry.type)) {
                    let layer = { type: 'Feature', properties: {}, geometry: { type: feature.geometry.type, coordinates: feature.geometry.coordinates } }
                    layer.properties.name = feature.properties.hasOwnProperty("name") ? feature.properties.name : `Área ${index} - ${new Date().toISOString().split('.')[0]}`
                    webgis.layers['statistic'].push(layer)
                }
            })

            if (webgis.layers['statistic'].length == 0) {
                $.notify(`Nenhuma geometria de Polígono válida...`, { className: "error", position: "right bottom" })
            }
            else {
                webgis.layers['statistic'] = L.geoJSON(webgis.layers['statistic'], { fillOpacity: 0, weight: 1, color: '#000000' })
                webgis.layers['statistic'].addTo(webgis.map)
                webgis.map.fitBounds(webgis.layers['statistic'].getBounds())
            }

            collection = null
        }
    },
    upload: {
        icon: () => {
            return L.icon({
                iconUrl: `${webgis.workspace}/img/icons/camera.png`,
                iconSize: [30, 30]
            })
        },
        insert: () => {
            $.notify("O envio será concluído em instantes, aguarde...", { className: "info", position: "right bottom" })
            $('#upload-modal').modal('hide')

            var formdata = new FormData(document.getElementById("upload-form"))

            $.ajax({
                type: 'POST',
                url: `${webgis.workspace}/upload/insert`,
                data: formdata,
                processData: false,
                contentType: false,
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                }
            }).done(function (data) {
                if (data[0]) {
                    $.notify(data[1], { className: "success", position: "right bottom" })
                    $("#upload-lat,#upload-lng,#upload-origin,#upload-type,#upload-subject,#upload-registered,#upload-obs,#upload-files").val("")
                } else {
                    $.notify(data[1], { className: "error", position: "right bottom" })
                }
            }).fail(function (jqXHR, textStatus) {
                $.notify("Erro ao subir imagens", { className: "error", position: "right bottom" })
            })
        },
        list: () => {
            webgis.upload.markers.clearLayers()

            if ($('#input-photos').is(':checked')) {
                let year = new Date().getFullYear() - 1

                if ($('#select-historic option:selected').val() != "0" && $('#select-historic option:selected').val() != "Período") {
                    year = $('#select-historic option:selected').val()
                }

                $.getJSON(`${webgis.workspace}/upload/list/${year}`, function (data) {
                    const icon = webgis.upload.icon()

                    data.forEach(item => {
                        if (item.status) {

                            let marker = L.marker([parseFloat(item.lat), parseFloat(item.lng)], { icon: icon })

                            var container = $('<div />')

                            container.on('click', '.icon-cam-map', function () {
                                $(".leaflet-popup-close-button")[0].click()
                                webgis.upload.show(item.id)
                            })

                            container.html(
                                `<div class="row">
                                    <div class="col-5 lasa-blue-color">Registro: </div>
                                    <div class="col-7 lasa-orange-color font-weight-bold">${item.registered_at_str.substring(0, 10)} </div>
                                </div>
                                <hr />
                                <div class="row">
                                    <div class="col-12 lasa-orange-color font-weight-bold">${item.subject} </div>
                                </div>
                                <hr />
                                <div class="row">
                                    <button type="button" class="btn btn-block font-weight-bold text-light lasa-orange-bg lasa-blue-hover icon-cam-map" upload-id="${item.id}" > Visualizar  / <small>View</small></button>
                                </div>`)

                            marker.bindPopup(container[0])
                            webgis.upload.markers.addLayer(marker)
                        }
                    })
                    webgis.upload.markers.addTo(webgis.upload.markers)
                })
            }
        },
        show: (id) => {
            $.notify("Carregando imagens, por favor aguarde....", { className: "info", position: "right bottom" })

            $.ajax({ url: `${webgis.workspace}/upload/${id}`, }).done(function (data) {

                $("#div-owl-carousel").html(
                    `<span class="owl-caption">
                        <b>
                            ${data.upload.registered_at_str.substring(0, 10)} | Lon,Lat: [${data.upload.lng}, ${data.upload.lat}] | Origem: ${data.upload.origin_str} |  Tipo: ${data.upload.type_str}
                            <br />
                            <small>${data.upload.obs}</small>
                        </b>
                    </span>`
                )
                $('#div-owl-carousel').append('<div class="owl-carousel owl-theme" id="owl-carousel">')

                data.paths.forEach((path, index) => {
                    $('#owl-carousel').append(`<img id="upload-img-load-${index}" src="${webgis.workspace}/uploads/${path}" style="height:${$(document).height() * 0.8}px" />`);
                })

                setTimeout(function () {
                    $("#upload-title").text(data.upload.subject)

                    $('#upload-list-modal').modal('show')
                    setTimeout(function () {
                        $('#owl-carousel').owlCarousel({
                            items: 1,
                            margin: 10,
                            loop: true,
                            nav: true,
                            autoWidth: true,
                            autoHeight: true,
                            autoplay: true,
                            autoplayTimeout: 5000,
                            autoplayHoverPause: true
                        })
                    }, 1000)
                }, 5000)
            })

        }
    },
    util: {
        clean: {
            all: () => {
                webgis.util.clean.historic()
                webgis.util.clean.nrt()
                webgis.util.clean.area()
                webgis.util.clean.ceasefire()
            },
            historic: () => {
                if ('historic' in webgis.layers) {
                    webgis.map.removeLayer(webgis.layers[`historic`])
                }
            },
            nrt: () => {
                $($('#select-nrt option').get().reverse()).each(function (index) {
                    if (webgis.layers[`nrt-${$(this).val()}`]) {
                        webgis.map.removeLayer(webgis.layers[`nrt-${$(this).val()}`])
                        delete webgis.layers[`nrt-${$(this).val()}`]
                    }
                })
            },
            area: () => {
                if (webgis.layers.area) {
                    webgis.map.removeLayer(webgis.layers.area)
                }
            },
            ceasefire: () => {
                if (webgis.layers.ceasefire) {
                    webgis.map.removeLayer(webgis.layers.ceasefire)
                }
            },
            statistic: {
                all: () => {
                    try {
                        for (index in webgis.layers) {
                            if (index.includes('statistic')) {
                                webgis.map.removeLayer(webgis.layers[index])
                            }
                        }
                    } catch (err) { }
                },
                specific: (name) => {
                    if (webgis.layers[name]) {
                        webgis.map.removeLayer(webgis.layers[name])
                    }

                }
            }
        }
    },
    validation: {
        upload: () => {
            const fields_id = ['upload-lng', 'upload-lat', 'upload-origin', 'upload-type', 'upload-registered', 'upload-subject', 'upload-obs', 'upload-files']

            fields_id.forEach(function (field, index) {
                $(`#${field}`).removeClass("border-danger")
            })

            let empty = false
            fields_id.forEach(function (field, index) {
                if ($(`#${field}`).val() == "") {
                    $(`#${field}`).addClass("border-danger")
                    empty = true
                }
            })

            if (empty) {
                $.notify("Um ou mais campos estão vazios no formulário", { className: "error", position: "right bottom" })
                return
            }

            if ($(`#upload-lng`).val().length > 3 && isNaN($(`#upload-lng`).val())) {
                $.notify("Os campos de coordenadas devem ser números com '.' para separação - Ex: -43.2685", {
                    className: "error",
                    position: "right bottom"
                })
                $(`#upload-lng`).addClass("is-invalid")
                return

            }

            if ($(`#upload-lat`).val().length > 3 && isNaN($(`#upload-lat`).val())) {
                $.notify("Os campos de coordenadas devem ser números com '.' para separação - Ex: -23.8945", {
                    className: "error",
                    position: "right bottom"
                })
                $(`#upload-lat`).addClass("is-invalid")
                return
            }


            if ($('#upload-subject').val().includes("\"") || $('#upload-subject').val().includes("\'")) {
                $.notify("O assunto não deve conter aspas simples ou dupla.", {
                    className: "error",
                    position: "right bottom"
                })
                $(`#upload-subject`).addClass("is-invalid")
                return
            }

            if ($('#upload-obs').val().includes("\"") || $('#upload-obs').val().includes("\'")) {
                $.notify("A descrição não deve conter aspas simples ou dupla.", {
                    className: "error",
                    position: "right bottom"
                })
                $(`#upload-obs`).addClass("is-invalid")
                return
            }

            if ($("#upload-files").get(0).files.length == 0) {
                $.notify("Não foram adicionados arquivos para esse envio.", {
                    className: "error",
                    position: "right bottom"
                })
                $(`#upload-files`).addClass("is-invalid")
                return
            } else if ($("#upload-files").get(0).files.length > 4) {
                $.notify("É possível adicionar somente até 4 arquivos.", { className: "error", position: "right bottom" })
                $(`#upload-files`).addClass("is-invalid")
                return
            }

            webgis.upload.insert()
        }
    }
}

$(document).ready(function () {
    const navbar = $('.navbar')
    const navbarHeight = navbar.height()
    const fixedHeader = $('.fixed-header')
    const fixedHeaderHeight = fixedHeader.height()
    const menu = $('.sidebar-content')

    fixedHeader.css('padding-top', (navbarHeight + 20) + "px")
    menu.css('margin-top', fixedHeaderHeight + "px")

    $('#notice-modal').modal('show');

    webgis.init.all()
})